import { data } from '../../../globals/data/storage-service';
import ServicesPageHelmet from '../../helmets/ServicesPageHelmet';
import Banner from '../../sections/common/banner';
import Intro from '../../sections/common/intro';
import SectionBlogs2 from '../../sections/home/index2/section-blogs2';
import SectionEstimation2 from '../../sections/home/index2/section-estimation2';

const Storage = () => {
  return (
    <>
      <ServicesPageHelmet />
      <Banner _data={data.banner} />
      <Intro _data={data.intro} />

      {/* <SectionServices2 _data={data.services} /> */}
      <SectionEstimation2 _data={data.estimation} />
      <SectionBlogs2 _data={data.blogs} />
    </>
  );
};

export default Storage;
